/**
 * A BEÁLLÍTÁSOK MEGERŐSÍTŐ ABLAKA — a cégek és a felhasználók szeletének közös.
 *
 * ⚠️ KÖZÖS, MERT A VISELKEDÉSE MÁR NEM TRIVIÁLIS. Két másolatban a fókusz és az
 * `Escape` kezelése előbb-utóbb az egyikből kimaradna — és pont azon a fülön,
 * amit senki nem próbál végig billentyűvel.
 *
 * ═══ AZ `Escape` NEM ITT ÉL ═══
 *
 * Hanem a lap regiszterében, a szelet jelzése alapján (`useSettingsLayer`).
 * Egy saját `onKeyDown` csak addig fogná meg, amíg a fókusz bent van — egy
 * mellé kattintás után a leütés az egész lapot zárná.
 *
 * A FÓKUSZ A „MÉGSE"-N ÁLL, NEM AZ „IGEN"-EN. Egy elütött `Enter` így nem
 * inaktivál semmit; a döntés egy szándékos lépés marad.
 */

import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDialogFocus } from '@/hooks/useDialogFocus';

export interface ConfirmDialogProps {
  /** A KÖVETKEZMÉNY, nem „biztos vagy benne" — a hívó szeletének szövege. */
  message: string;
  yesLabel: string;
  noLabel: string;
  onYes: () => void;
  onNo: () => void;
}

export function ConfirmDialog({ message, yesLabel, noLabel, onYes, onNo }: ConfirmDialogProps) {
  const { t } = useTranslation();
  const noButton = useRef<HTMLButtonElement>(null);

  // Nyitáskor a fókusz az ablakba kerül, záráskor VISSZA oda, ahonnan jött, és
  // közben BENT IS MARAD (#16/2) — a három együtt a `useDialogFocus`-ban él.
  // A kezdőpont a „Mégse", nem az első fókuszálható elem: lásd a fejlécet.
  const dialog = useDialogFocus<HTMLDivElement>(noButton);

  return (
    <div className="overlay">
      {/* A SZEREP ÉS A CSAPDA UGYANAZON AZ ELEMEN: a párbeszéd a kártya, nem
          a mögötte sötétedő réteg. */}
      <div
        className="card"
        ref={dialog}
        role="dialog"
        aria-modal="true"
        aria-label={t('settings.title')}
      >
        <p>{message}</p>
        <div className="settings__toolbar">
          <button type="button" className="settings__primary" onClick={onYes}>
            {yesLabel}
          </button>
          <button ref={noButton} type="button" onClick={onNo}>
            {noLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
